<template>
  <span class="auth-popup-controller" aria-hidden="true"></span>
</template>

<script>
import layer from 'layui-layer'
import { bindAuthPopupHost, unbindAuthPopupHost } from '@/services/auth-popup'

const COMPACT_AUTH_REDIRECT = 0

export default {
  name: 'AuthPopup',
  data () {
    return {
      activeIndex: null
    }
  },
  created () {
    bindAuthPopupHost(this)
  },
  beforeDestroy () {
    unbindAuthPopupHost(this)
  },
  methods: {
    compactAuthRoute (url) {
      if (typeof url !== 'string') {
        return null
      }
      try {
        const target = new URL(url, window.location.origin)
        const configuredLogin = new URL(process.env.VUE_APP_WEB_LOGIN_URL || '/login', window.location.origin)
        const isAllowedOrigin = target.origin === window.location.origin || target.origin === configuredLogin.origin
        const pathname = target.pathname.replace(/\/+$/, '')
        const configuredPathname = configuredLogin.pathname.replace(/\/+$/, '')
        if (!isAllowedOrigin) {
          return null
        }
        if (pathname === '/register') {
          return '/h5/register'
        }
        if (pathname === '/login' || pathname === configuredPathname) {
          return '/h5/login'
        }
        return null
      } catch (e) {
        const pathname = url.split(/[?#]/)[0].replace(/\/+$/, '')
        if (pathname === '/register') {
          return '/h5/register'
        }
        return pathname === '/login' ? '/h5/login' : null
      }
    },
    redirectCompactAuth (path) {
      if (this.$route && this.$route.path === path) {
        return
      }
      const navigation = this.$router.push(path)
      if (navigation && typeof navigation.catch === 'function') {
        navigation.catch(() => {})
      }
    },
    open (url, options = {}) {
      if (!url) {
        return null
      }
      const compact = window.matchMedia
        ? window.matchMedia('(max-width: 768px)').matches
        : window.innerWidth <= 768
      const compactRoute = compact ? this.compactAuthRoute(url) : null
      if (compactRoute) {
        this.close()
        this.redirectCompactAuth(compactRoute)
        return COMPACT_AUTH_REDIRECT
      }
      const defaultSkin = compact
        ? 'login-demo-class home-auth-layer'
        : 'home-auth-layer'
      const config = {
        skin: options.skin === undefined ? defaultSkin : options.skin,
        area: options.area || ['885px', '501px'],
        type: 2,
        title: false,
        shadeClose: options.shadeClose !== false,
        anim: -1,
        content: [url, 'no']
      }
      let index = null
      config.end = () => {
        if (this.activeIndex === index) {
          this.activeIndex = null
        }
        if (typeof options.onClose === 'function') {
          options.onClose()
        }
      }
      if (typeof options.onOpen === 'function') {
        config.success = options.onOpen
      }
      index = layer.open(config)
      this.activeIndex = index
      return index
    },
    close (index) {
      const targetIndex = index !== null && index !== undefined
        ? index
        : this.activeIndex
      if (typeof targetIndex === 'number' && targetIndex > COMPACT_AUTH_REDIRECT) {
        layer.close(targetIndex)
      }
    }
  }
}
</script>

<style scoped>
.auth-popup-controller { display: none; }
</style>
